import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';

import { WorkspaceShorter } from 'projects/ngx-messaging/src/modules/chat/interfaces/IWorkspace';
import { PhonesService } from 'projects/ngx-messaging/src/modules/chat/services/phones.service';

@Injectable()
export class ChatRoutesService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private phonesService: PhonesService) {}

  getWorkspace(routerState: RouterStateSnapshot | null = null): WorkspaceShorter {
    const urlSegments = this.getSegments(routerState);
    return urlSegments[1] as WorkspaceShorter;
  }

  /** @deprecated Use {@link getWorkspace} instead */
  getWorskpace(routerState: RouterStateSnapshot | null = null): WorkspaceShorter {
    return this.getWorkspace(routerState);
  }

  getSegments(routerState: RouterStateSnapshot | null = null): string[] {
    if (!routerState) {
      routerState = this.router.routerState.snapshot;
    }
    const index = routerState.url.indexOf('?');
    return index !== -1 ? routerState.url.substring(0, index).split('/') : routerState.url.split('/');
  }

  isRouteByType(param: string): boolean {
    const urlSegments = this.getSegments();
    return urlSegments[2] === param;
  }

  getChannelUID(): string {
    const urlSegments = this.getSegments();
    return urlSegments[3];
  }

  getChannelCDKPhoneNumber(): string {
    const urlSegments = this.getSegments();
    return this.phonesService.setPhoneNumber(urlSegments[3]);
  }

  getChannelPhoneNumber(): string {
    const phoneNumber = this.activatedRoute.snapshot.queryParams['phoneNumber'] as string;
    return this.phonesService.setPhoneNumber(phoneNumber);
  }

  getStringParam(key: string): string | null {
    return (this.activatedRoute.snapshot.queryParams[key] as string) || null;
  }

  getBooleanParam(key: string): boolean | null {
    const value = this.activatedRoute.snapshot.queryParams[key] as string;
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  }

  getColorParam(key: string): string | null {
    const value = this.activatedRoute.snapshot.queryParams[key] as string;
    if (value) {
      return '#' + value;
    }
    return null;
  }

  getChannelSearchTerm(): string {
    return this.activatedRoute.snapshot.queryParams['searchTerm'];
  }

  getCanUseCache(): boolean {
    return (this.activatedRoute.snapshot.queryParams['canUseCache'] as boolean) || false;
  }

  getChannelOwner(): string | null {
    return this.activatedRoute.snapshot.queryParams['ownerExternalID'] || null;
  }

  getCDKFilters(): {
    phoneNumber: string;
    customerId: string;
    externalId: string;
    ownerExternalID: string;
  } | null {
    const filters = this.activatedRoute.snapshot.queryParams['filters'] as string;
    return filters ? JSON.parse(filters.replace(/\\/g, '')) : null;
  }
}
